import {makeStyles} from "@material-ui/core";
import { lightTheme } from '../../themes'
const Colors = {
  white: "#FFF",
  default: "#3b3b3b",
  gray: "#bebfc0",
  greyOne: "#fafafa",
  yellow: "#fecf33",
  lightOrange: "#fdbd39",
  peach: "#ee6723",
  periwinkle: lightTheme.palette.primary.main,
  darkPastelGreen: "#4abc4e",
  maize: "#fbc04f",
  dustyRed: "#d63031",
  mediumGrey: "#4a4a4a",
  lightGrey: "#96979a",
  veryLightGrey: "#f4f4f4",
  bluish: "#297ec8",
  lightPeriwinkle: "#e3e5ea",
  reddishOrange: "#fa6725",
  veryLightPink: "#e4e4e4",
  blueGrey: "#9da5b6",
  redishOrange: "#fa6725",
  lightBlue: "#a1c5ef",
  lightBlueTwo: "#f4f3ff",
  pinkishGrey: "#cccccc",
  warmGrey: "#9b9b9b",
  purple: "#8447f6",
  veryLightBlue: "#a5ccec",
};

export const statusColor = {
  IN_PROGRESS: "#887fff",
  PENDING: "#fbc04f",
  SUCCEEDED: "#4abc4e",
  DROPOFF_SUCCEEDED: "#4abc4e",
  FAILED: "#d63031",
  UNROUTED: "#bebfc0",
  EXCEPTION: "#d63031",
  ERRORED: "#d63031",
};

export const useStyles = makeStyles(theme => ({
  container: {
    textAlign: "left",
    backgroundColor: "white",
    boxSizing: "border-box",
    borderRadius: 3,
    lineHeight: "1.5em",
    fontSize: 15,
    boxShadow: "0px 0px 1px #888",
    minHeight: 44,
    padding: 5,
    margin: "10px 1px",
    overflow: "hidden",
    cursor: "pointer",
    position: "relative",
    borderRight: "solid 6px",
  },
  timeWindow: {
    fontFamily: "AvenirNext-DemiBold",
    fontSize: 12,
    fontWeight: 600,
    color: "#4a90e2",
    marginBottom: 5,
  },
  smallText: {
    fontFamily: "AvenirNext-Medium",
    fontSize: 11,
    fontWeight: 500,
    color: "#3b3b3b",
    lineHeight: "1.3em",
  },
  text: {
    fontFamily: "AvenirNext-Medium",
    fontSize: 13,
    fontWeight: 500,
    color: "#3b3b3b",
    lineHeight: "1.3em",
    marginBottom: 5,
    wordBreak: "break-word",
  },
  name: {
    fontFamily: "AvenirNext-DemiBold",
    fontSize: 14,
    fontWeight: "bold",
    color: "#3b3b3b",
    marginBottom: 5,
    wordBreak: "break-word",
  },
  image: {
    maxWidth: 50,
    maxHeight: 50,
  },
  blur: {
    color: "transparent",
    textShadow: "0 0 10px rgba(0,0,0,0.6)",
  },
  imgBlur: {
    filter: 'blur(8px) grayscale(100%)',
    WebkitFilter: 'blur(8px) grayscale(100%)',
  },
}))
